import {Block, Button} from "../../components/";

const text = "Кажется, мы проделали кучу работы и проверили твою внимательность. А теперь со сверхЗВУКовой скоростью протестим твои знания!";

export const SberFirstBlock = ({handler}) => {
    return (
        <Block name="box-blue-12" title="ого!" desc={text}>
            <Button id="button-next-2" text="далее" handler={handler}/>
        </Block>
    )
}